import styled from "@emotion/styled";

import { globalColors } from "../../../Utils/colors";
import { PreviewImageContainerPropType } from "./utils";

const RootContainer = styled.div`
  height: 100%;
`;

const ImageContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  height: calc(100% - 150px);
`;

const PreviewImage = styled.img<PreviewImageContainerPropType>`
  height: ${(props) => (props.isLessThan1024 ? "250px" : "310px")};
`;

const TextContainer = styled.div`
  height: 50px;
  text-align: center;
`;

const SubHeaderText = styled.div`
  color: ${globalColors.textLightGrey};
  font-family: "Poppins";
  font-size: 14px;
  font-weight: 400;
`;

const HeaderText = styled.div`
  color: ${globalColors.primary};
  font-family: "Poppins";
  font-size: 16px;
  font-weight: 700;
`;

const ButtonContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100px;
`;

export {
  RootContainer,
  ImageContainer,
  PreviewImage,
  TextContainer,
  SubHeaderText,
  HeaderText,
  ButtonContainer,
};
